import { typeofbacteria_qpt } from './pdfScoreConfig_allergy.js';

// Mapping from full names to abbreviated names
const bacteriaNameMapping_allergy = {
    // Core bacteria
    'Akkermansia muciniphila': 'A. muciniphila',
    'Faecalibacterium prausnitzii': 'F. prausnitzii',
    
    // Harmful bacteria
    'Candida albicans': 'C. albicans',
    'Escherichia coli': 'E. coli',
    'Staphylococcus aureus': 'S. aureus',
    'Ruminococus bromii': 'R. bromii',
    
    // Beneficial bacteria
    'Bifidobacterium bifidum': 'B. bifidum',
    'Bifidobacterium lactis': 'B. lactis',
    'Lactobacillus acidophilus': 'L. acidophilus',
    'Lactobacillus reuteri': 'L. reuteri',
    'Lactobacillus rhamnosus': 'L. rhamnosus',
};

// Configuration for displaying beneficial bacteria names when they are deficient or slightly deficient
export const pdfTextPreciseConfig_allergy = {
    // Configuration for beneficial bacteria deficiency display
    beneficial_bacteria_deficiency: [
        {
            page: 14,
            version: 'eng',
            Xpostext: 83,
            Ypostext: 444,
            fontsize: 10,
            maxWidth: 240,
            condition: 'beneficial_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 14,
            version: 'eng',
            Xpostext: 290,
            Ypostext: 260,
            fontsize: 10,
            maxWidth: 210,
            condition: 'core_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 14,
            version: 'eng',
            Xpostext: 287,
            Ypostext: 623,
            fontsize: 10,
            maxWidth: 240,
            condition: 'harmful_bacteria',
            target_labels: ['Excessive', 'Slightly Excessive'],
            description: ''
        },
        {
            page: 13,
            version: 'thai',
            Xpostext: 83,
            Ypostext: 444,
            fontsize: 10,
            maxWidth: 240,
            condition: 'beneficial_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 13,
            version: 'thai',
            Xpostext: 290,
            Ypostext: 260,
            fontsize: 10,
            maxWidth: 230,
            condition: 'core_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 13,
            version: 'thai',
            Xpostext: 287,
            Ypostext: 623,
            fontsize: 10,
            maxWidth: 240,
            condition: 'harmful_bacteria',
            target_labels: ['Excessive', 'Slightly Excessive'],
            description: ''
        }
    ]
};

// Helper function to get deficient beneficial bacteria names
export const getDeficientBacteriaNames = (bacteriaResults, bacteriaType = 'beneficial_bacteria', targetLabels = ['Deficient', 'Slightly Deficient']) => {
    const bacteriaList = typeofbacteria_qpt[bacteriaType] || [];
    const deficientBacteria = [];

    bacteriaList.forEach(bacteriaName => {
        const result = bacteriaResults[bacteriaName];
        if (result && targetLabels.includes(result.label)) {
            deficientBacteria.push(bacteriaName);
        }
    });

    return deficientBacteria;
};

// Helper function to format bacteria names for display with abbreviation mapping
export const formatBacteriaNames = (bacteriaNames) => {
    if (bacteriaNames.length === 0) {
        return 'None';
    }
    
    // Map full names to abbreviated names
    const abbreviatedNames = bacteriaNames.map(name => bacteriaNameMapping_allergy[name] || name);
    return abbreviatedNames.join(', ');
};

// Helper function to get configuration for specific page and language
export const getTextConfigForPage = (pageNumber, language = 'eng') => {
    const configs = pdfTextPreciseConfig_allergy.beneficial_bacteria_deficiency;
    return configs.find(config => config.page === pageNumber && config.version === language);
};
